import React, { useEffect, useState } from 'react'
import { Delete_Period_Api, GetAll_Paging_Period_Api } from '../../API/PeriodApi';
import { Button, Col, Modal, Pagination, Row } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined, RollbackOutlined, WarningOutlined, ForkOutlined, CloseOutlined, DoubleRightOutlined, ScheduleOutlined, SolutionOutlined, HistoryOutlined } from '@ant-design/icons';
import { LotteryStatus } from './LotteryStatus';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
// ======================================================================
export const AllPeriodComponent = ({
    setLoading,
    showMessage,
    categoryId,
    categoryTitle,
    version,
    currentPage,
    setCurrentPage,
    onClickItem,
    isShowAddButton = true,
    onAddClick,
    onBackClick,
    isShowEditButton = true,
    onEdit,
    isShowDeleteButton = true,
    onRowDeleted,
    isShowLimitationButton = true,
    onLimitationClick,
    isShowSubPeriodButton = true,
    onSubPeriodClick,
    isShowReservesButton = true,
    onReservesClick,
    isShowWonButton = true,
    onWonClick,
    isShowLotteryButton = true,
    onLotteryClick,
    isShowFoodsButton = true,
    onFoodsClick,

}) => {
    // ======================================================================
    const [periods, setPeriods] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [currentPage, version]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_Period_Api({ pageNumber: currentPage, categroryId: categoryId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setPeriods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        setLoading(true);
        try {
            let data = await Delete_Period_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const dayDiffFromToday = (dt) => {
        // console.log("dt", dt);
        dt = new Date(dt);
        // تاریخ امروز
        const today = new Date();
        // محاسبه اختلاف بر حسب میلی‌ثانیه
        const differenceInTime = dt.getTime() - today.getTime();
        // تبدیل به روز
        return Math.ceil(differenceInTime / (1000 * 3600 * 24));
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    <Button onClick={() => onBackClick()}>
                        <DoubleRightOutlined />
                        بازگشت
                    </Button>
                </Col>
                <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                    <h2 >
                        دوره های ثبت نام {categoryTitle}
                    </h2>
                </Col>
                <Col xs={8} sm={8} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                    {isShowAddButton ?
                        <Button className='btn-primary' onClick={() => onAddClick()} >
                            <PlusOutlined />
                            ایجاد رکورد جدید</Button> : <></>
                    }

                </Col>
            </Row>
            <div className='container'>

                {periods.map((period, key) =>
                    <>
                        <Row key={key} className="valueRow" style={onClickItem ? { cursor: 'pointer' } : {}}>
                            <Col span={3} onClick={() => { if (onClickItem) onClickItem(period.id) }} style={{ padding: "5px" }}>
                                {period.title}
                            </Col>
                            <Col span={21} style={{ textAlign: "left" }}>

                                {period.isLottery ?
                                    <>
                                        {/* آنهایی که قرعه کشی دارند */}
                                        {isShowLotteryButton && period.isLottery && dayDiffFromToday(period.lotteryDate) == 0 && period.lotteryStatus != "LotteryConfirmed" ?

                                            <Button
                                                className='btn-info' style={{ marginLeft: "2px" }} onClick={() => onLotteryClick(period.id, period.title)}>
                                                <HistoryOutlined />
                                                قرعه کشی

                                            </Button>
                                            :
                                            <span style={{ float: 'right', marginRight: '10px', paddingTop: '7px' }}>
                                                <LotteryStatus
                                                    lotteryStatus={period.lotteryStatus}
                                                />
                                            </span>}


                                    </>
                                    : <></>}
                                {isShowWonButton && period.isLottery && period.lotteryStatus == "LotteryConfirmed" ?
                                    <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onWonClick(period.id, period.title)}>
                                        <SolutionOutlined />
                                        برنده ها
                                    </Button>
                                    : <></>}
                                {isShowReservesButton ?
                                    <Button className='btn-primary' style={{ marginLeft: "2px" }} onClick={() => onReservesClick(period.id, period.title)}>
                                        <SolutionOutlined />
                                        ثبت نام ها
                                    </Button>
                                    : <></>}
                                {isShowFoodsButton ?
                                    <Button className='btn-secondary' style={{ marginLeft: "2px" }} onClick={() => onFoodsClick(period.id, period.title)}>
                                        <SolutionOutlined />
                                        غذا/پارکینگ
                                    </Button>
                                    : <></>}


                                {isShowLimitationButton ?
                                    <Button className='btn-warning' style={{ marginLeft: "2px" }} onClick={() => onLimitationClick(period.id, period.title)}>
                                        <WarningOutlined />
                                        محدودیت ها
                                    </Button>

                                    : <></>}
                                {isShowSubPeriodButton ?
                                    <Button className='btn-secondary' style={{ marginLeft: "2px" }} onClick={() => onSubPeriodClick(period.id, period.title)}>
                                        <ForkOutlined />
                                        زیر دوره ها</Button> : <></>
                                }
                                {isShowEditButton ?
                                    <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(period.id)}>
                                        <EditOutlined />
                                        ویرایش
                                    </Button> : <></>
                                }
                                {isShowDeleteButton ?
                                    <Button
                                        className='btn-danger'
                                        onClick={() => {
                                            Modal.confirm({
                                                title: 'آیا از حذف ' + period.title + ' اطمینان دارید؟',
                                                onOk: () => { deleteRow(period.id) },
                                                footer: (_, { OkBtn, CancelBtn }) => (
                                                    <>
                                                        <CancelBtn />
                                                        <OkBtn />
                                                    </>
                                                ),
                                            });
                                        }}
                                    >
                                        <DeleteOutlined />
                                        حذف</Button> : <></>
                                }

                            </Col>
                        </Row>
                    </>
                )}
            </div>
            <ConfigProvider direction="rtl" locale={faIR}>
                <Pagination current={currentPage}
                    showSizeChanger={false}
                    showQuickJumper={false}
                    align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
            </ConfigProvider>
        </>
    )
}